import configData from './config.json';

export default configData;

